import { falsyCheckDate } from 'utils';
import { DataCellProps } from '../types';

export const TeamCreatedAtCell = ({ team }: DataCellProps) => {
  return <div>{falsyCheckDate(team.created_at)}</div>;
};
